export const text = {
  0: "0.6875rem",
  1: "0.75rem",
  2: "0.8125rem",
  3: "0.9375rem",
  4: "1.125rem",
  5: "1.25rem",
  6: "1.5rem",
  7: "1.875rem",
  8: "2.25rem",
  9: "3rem",
  "code-0": "0.625rem",
  "code-1": "0.688rem",
  "code-2": "0.812rem",
  "code-4": "1.062rem",
  "code-5": "1.188rem",
  "code-6": "1.438rem",
  "code-7": "1.75rem",
  "code-8": "2.125rem",
  "code-9": "2.875rem",
};
